export enum BiopsyReason {
    SuspectedNewRejection = 0,
    OngoingRejection = 1,
    NotRelatedToRejection = 2,
    SurveillanceProtocol = 3
}